import React from 'react';
import { SvgIcon } from '@mui/material';

function HalalIcon({ color = '#757575', ...props }) {
  return (
    <SvgIcon viewBox="0 0 64 64" sx={{ width: 20, height: 20 }} {...props}>
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect opacity="0.15" x="2.48413" y="1.97949" width="20" height="20" rx="4" fill={color} />
        <path d="M8.66504 16.9486V7.05151H10.5345V11.1203H14.9607V7.05151H16.8302V16.9486H14.9607V12.8661H10.5345V16.9486H8.66504Z" fill={color} />
      </svg>

    </SvgIcon>
  );
}
export default HalalIcon;
